import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../TierProductCardDumb/utils';
import s from './TierPricePerMonth.scss';
/* {price}/month typography */ const TierPricePerMonth = ({ price , className  })=>{
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement("span", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['price']
    }, formatPrice(price)), /*#__PURE__*/ React.createElement("span", {
        className: s['period']
    }, "/", t('deviationview.tierCard.pricePeriod.month')));
};
TierPricePerMonth.displayName = 'TierPricePerMonth';
export default TierPricePerMonth;
